import "core-js/stable";
import React from 'react';
import {render} from 'react-dom';
import {connect, Provider} from 'react-redux';
import reduxStore from './ReduxStore';
import {BrowserRouter, withRouter} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import "../../css/index.scss";
import SideBar from "../sidebar/SideBar";
import {MessagePopupCore} from "dts-react-common";

const propTypes = {};

const defaultProps = {};

const mapStateToProps = state => ({});

class AppClass extends React.Component {
	render() {
		return (
			<main className="app-layout">
				<React.Fragment>
					<section className="content-left">
						<SideBar/>
					</section>
					<section className="content-right">
						<AppRoutes {...this.props}/>
					</section>
				</React.Fragment>
				<MessagePopupCore/>
			</main>
		);
	}
}

AppClass.propTypes = propTypes;
AppClass.defaultProps = defaultProps;

const App = withRouter(connect(mapStateToProps)(AppClass));


render(
	<BrowserRouter basename="/">
		<Provider store={reduxStore}>
			<App/>
		</Provider>
	</BrowserRouter>
	, document.getElementById('react')
);
